<ng-container *ngIf="medium && medium.id">
  <td style="width: 0; white-space: nowrap">
    @if (isInFolderContext) {
      <div>{{ medium?.folder?.name ?? '' }}</div>
    }
    @if (!isInModalContext) {
      <button (dragend)="dragendEmitter.emit()" (dragstart)="dragstartEmitter.emit({event: $event, item: medium})"
              [draggable]="medium?.id" class="btn btn-hover-primary">
        <sb-icon icon="drag"></sb-icon>
      </button>
    }
  </td>
  <td>
    <sb-comp-image-name-wrapper [medium]="medium" [still]="true" [loading]="medium.uploading || medium.processing">
      <span firstLine class="cursor-pointer" (click)="!isInModalContext?clickEvent.emit():''" [innerHtml]="medium?.name|truncate:30"></span>
      <div secondLine>
        <ng-container *ngIf="!medium.uploading && !medium.processing">
          <small *ngIf="!medium?.locked && medium.usageCount === 0" class="red">
            <sb-icon icon="lockOpen"></sb-icon>&nbsp;&nbsp;{{
              'lang.mediumExplorer.notReadyUse' |
                translate
            }}
          </small>
          <small *ngIf="medium?.locked && medium.usageCount === 0" class="yellow">
            <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.readyUse' | translate }}
          </small>
          <small *ngIf="medium?.locked && medium.usageCount >= 1" class="green">
            <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.inUse' | translate }}
          </small>
        </ng-container>
      </div>
      <div thirdLine>
        {{ medium?.company?.name }}
      </div>
      <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="medium?.id"
               [dtoType]="tagService.TaggableDTO.Medium"
               [tags]="medium?.tags" fourthLine></sb-tags>
    </sb-comp-image-name-wrapper>
  </td>
  <td>
    <sb-icon class="mr-1" icon="motives"></sb-icon>
    <sb-comp-link
      [title]="medium?.mediumGroup?.name ?? '-' | truncate : 25"
      [permission]="permissionService.Permission.medium_group_show"
      [condition]="!isInModalContext && medium?.mediumGroup?.id"
      [link]="util.RoutingID.mediumGroupEdit"
      [pathParams]="[{id: 'mediumGroupID', value: medium?.mediumGroup?.id}]"
      [tooltip]="'lang.mediumExplorer.switchMediumgroup' | translate">
    </sb-comp-link>
  </td>
  <td>
    <div class="tw-flex tw-gap-2">
      <sb-icon icon="templates"></sb-icon>
      <div [innerHTML]="medium?.templateGroup?.name ?? '-' | truncate : 25"></div>
    </div>
  </td>
  <td>
    <span style="white-space: nowrap;" [ngbTooltip]="all" container="body">
      <sb-icon class="mr-1" icon="product"></sb-icon>
      <span [innerHTML]="medium?.promotedProducts?.length >= 1 ? ((medium?.promotedProducts?.length=== 1 ?
        (medium?.promotedProducts[0]?.name)
        :medium?.promotedProducts?.length +' '+ ('lang.globals.products' | translate)) | truncate : 15)
        :'-'">
      </span>
    </span>
    <ng-template #all>
      <table class="table table-borderless">
        <ng-container *ngIf="medium?.promotedProducts?.length > 0; else noProducts">
          <tr *ngFor="let element of medium.promotedProducts">
            <td class="text-left" [innerHTML]="element?.name | truncate : 25"></td>
          </tr>
        </ng-container>
        <ng-template #noProducts>
          <tr>
            <td class="text-left" [innerHTML]="('lang.globals.noProducts' | translate) | truncate : 25"></td>
          </tr>
        </ng-template>
      </table>
    </ng-template>
  </td>
  <td>
    <div [class.red]="displayNoMatching"
         [ngbTooltip]="displayNoMatching? ('lang.globals.noMatchingResolution' | translate) : null">
      <sb-icon icon="marker"></sb-icon>
      {{ medium?.resolution?.id }}
      <sb-icon icon="attention" class="red" *ngIf="displayNoMatching"></sb-icon>
    </div>
  </td>
  <td>
    <sb-icon icon="clock"></sb-icon>
    {{ medium?.duration ? medium?.duration + 's' : '-' }}
  </td>
  <td>
    <div *ngIf="medium?.contentType" [ngSwitch]="true">
      <sb-icon *ngSwitchCase="medium?.contentType.indexOf('video') !== -1" icon="video"></sb-icon>
      <sb-icon *ngSwitchCase="medium?.contentType.indexOf('image') !== -1" icon="photo"></sb-icon>
      <sb-icon *ngSwitchDefault icon="brackets"></sb-icon>
      <span class="ml-1" [innerHTML]="medium?.contentType | truncate : 15"></span>
    </div>
    <div>
      <sb-icon icon="file"></sb-icon>
      {{ util.formatBytes(medium?.size) }}
    </div>
  </td>
  <td>
    <sb-comp-display-created [data]="medium"></sb-comp-display-created>
  </td>
  <td class="sticky-col last-col tableBg">
    <div class="d-flex justify-content-end">
      <ng-container *ngIf="!isInModalContext && multiSelect">
        <button (click)="selectEmitter.emit();"
                class="btn btn-hover-primary ml-1 mr-1"
                [ngClass]="{'btn-hover-primary--active' :isMediumInSelectedMedias(medium)}">
          <sb-icon *ngIf="isMediumInSelectedMedias(medium)" icon="boxChecked"></sb-icon>
          <sb-icon *ngIf="!isMediumInSelectedMedias(medium)" icon="box"></sb-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="isInModalContext && medium.locked">

        <button *ngIf="modalType==='groupSelect'" (click)="selectEmitter.emit();" [disabled]="medium['excluded']"
                class="btn btn-hover-primary ml-1 mr-1"
                [ngClass]="{'btn-hover-primary--active' :isMediumInSelectedMedias(medium) || medium['excluded']}">
          <sb-icon *ngIf="isMediumInSelectedMedias(medium) || medium['excluded']" icon="boxChecked"></sb-icon>
          <sb-icon *ngIf="!isMediumInSelectedMedias(medium) && !medium['excluded']" icon="box"></sb-icon>
        </button>
        <button *ngIf="modalType !== 'groupSelect'" (click)="selectEmitter.emit();" class="btn btn-hover-primary ml-1 mr-1">
          <sb-icon icon="boxChecked"></sb-icon>
        </button>
      </ng-container>
      <sb-table-buttons *ngIf="!isInModalContext && !multiSelect" class="d-flex justify-content-end">
        <button
          class="btn btn-primary"
          (click)="clickEvent.emit();"
          ngbTooltip="{{ 'lang.globals.openDetails' | translate }}" placement="left"
        >
          <sb-icon icon="details"></sb-icon>
        </button>
        <button
          class="btn btn-danger"
          [ngClass]="{ 'btn-secondary': medium.locked, 'btn-danger': !medium.locked }"
          [disabled]="medium.locked"
          (click)="deleteMedium.emit(medium)"
          ngbTooltip="{{ 'lang.globals.delete' | translate }}" placement="left"
        >
          <sb-icon icon="trash"></sb-icon>
        </button>
      </sb-table-buttons>
    </div>
  </td>
</ng-container>

<ng-container *ngIf="medium && !medium.id">
  <td colspan="100">
    <div class="d-flex align-items-center" style="font-size: 4rem;">
      <div class="mr-3" style="width: 80px;">
        <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="uploadAltAnimation"></sb-icon>
      </div>
      <h5 class="font-weight-bold m-0">
        {{ 'lang.globals.uploadFiles' | translate }}...
      </h5>
    </div>
  </td>
  <td colspan="100">
    <div class="d-flex align-items-center" style="font-size: 4rem;">
      <div class="mr-3" style="width: 80px;">
        <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="linkAnimation"></sb-icon>
      </div>
      <h5 class="font-weight-bold m-0">
        {{ 'lang.globals.processing' | translate }}...
      </h5>
    </div>
  </td>
</ng-container>
